import { t } from 'i18next'

import { ContractTenant } from '../../../../../common/validations'
import { ContractToTenantRole } from '../../../../../common/types'
import { isChildTenant } from '../../utils/isChildTenant'

const resolveContractRoleLabel = (tenantRole: ContractToTenantRole | null) => {
  switch (tenantRole) {
    case ContractToTenantRole.TENANT:
      return t('contractModification:tenantRoles.tenant')
    case ContractToTenantRole.SUBTENANT:
      return t('contractModification:tenantRoles.subtenant')
    case ContractToTenantRole.REPLACEMENT_APARTMENT_TENANT:
      return t('contractModification:tenantRoles.replacementApartmentTenant')
    case ContractToTenantRole.LEGAL_GUARDIAN:
      return t('contractModification:tenantRoles.legalGuardian')
    case ContractToTenantRole.SECONDARY_TENANT:
      return t('contractModification:tenantRoles.secondaryTenant')
    case ContractToTenantRole.NON_TENANT:
    case null:
      return undefined
  }
}

export const resolveTenantRoleLabel = (tenant: ContractTenant) => {
  const roleLabel = tenant.isContractParty
    ? t('contractModification:tenantChoices.contractParty')
    : resolveContractRoleLabel(tenant.tenantRole)

  if (roleLabel && isChildTenant(tenant)) {
    return t('contractModification:tenantRoles.minor', { role: roleLabel })
  }

  return roleLabel
}
